import { apiSlice } from "../../app/api/apiSlice";

export const patientApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    fetchPatientById: builder.mutation({
      query: (credentials) => ({
        url: `/patient/${credentials}`,
        method: "GET",
      }),
    }),
    fetchPatientCareteam: builder.mutation({
      query: (credentials) => ({
        url: `/patient/careteam/${credentials}`,
        method: "GET",
      }),
    }),
    fetchPatientHouseholdMembers: builder.mutation({
      query: (credentials) => ({
        url: `/patient/household-members/${credentials}`,
        method: "GET",
      }),
    }),
    fetchPatientPOCMembers: builder.mutation({
      query: (credentials) => ({
        url: `/patient/poc-members/${credentials}`,
        method: "GET",
      }),
    }),
    fetchPatientPrimaryProvider: builder.mutation({
      query: (credentials) => ({
        url: `/patient/primary-provider/${credentials.id}`,
        method: "POST",
        body: { ...credentials.body },
      }),
    }),
    fetchPatientPrimaryLocation: builder.mutation({
      query: (credentials) => ({
        url: `/patient/primary-location/${credentials.id}`,
        method: "POST",
        body: { ...credentials.body },
      }),
    }),
    createPOC: builder.mutation({
      query: (credentials) => ({
        url: `/patient/poc-members/${credentials.patientId}`,
        method: "POST",
        body: { ...credentials },
      }),
    }),
    updatePOC: builder.mutation({
      query: ({ id, ...credentials }) => ({
        url: `/patient/poc-members/${id}`,
        method: "PATCH",
        body: { ...credentials },
      }),
    }),
    deletePOC: builder.mutation({
      query: ({ id }) => ({
        url: `/patient/poc-members/${id}`,
        method: "DELETE",
      }),
    }),
    getNewPatients: builder.mutation({
      query: (credentials) => ({
        url: `/patient/new?organisationId=${credentials.organisationId}`,
        method: "GET",
      }),
    }),
    updatePatientNotes: builder.mutation({
      query: (credentials) => ({
        url: `/patient/notes/${credentials.patientId}`,
        method: "PATCH",
        body: credentials,
      }),
    }),
    updatePatient: builder.mutation({
      query: (credentials) => ({
        url: `/patient/${credentials.patientId}`,
        method: "PUT",
        body: credentials,
      }),
    }),
    fetchPlannerPatients: builder.mutation({
      query: (credentials) => ({
        url: `/patient/planner`,
        method: "POST",
        body: { ...credentials },
      }),
    }),
    createPatient: builder.mutation({
      query: (credentials) => ({
        url: `/patient`,
        method: "POST",
        body: { ...credentials },
      }),
    }),
    getInsurances: builder.mutation({
      query: (credentials) => ({
        url: `/patient/insurances/${credentials.practiceId}`,
        method: "GET",
      }),
    }),
    updateInsurance: builder.mutation({
      query: (credentials) => ({
        url: `/patient/${credentials.patientId}/insurances`,
        method: "POST",
        body: { ...credentials },
      }),
    }),
    getLocations: builder.mutation({
      query: (credentials) => ({
        url: `/patient/${credentials.patientId}/locations`,
        method: "GET",
      }),
    }),
    suggestLocations: builder.mutation({
      query: (credentials) => ({
        url: `/patient/suggest-locations`,
        method: "POST",
        body: { ...credentials },
      }),
    }),
    attachLocation: builder.mutation({
      query: (credentials) => ({
        url: `/patient/attach-location`,
        method: "POST",
        body: { ...credentials },
      }),
    }),

    validateCoords: builder.mutation({
      query: (credentials) => ({
        url: `/location/validate-coordinates`,
        method: "POST",
        body: { ...credentials },
      }),
    }),
    updateCoords: builder.mutation({
      query: (credentials) => ({
        url: `/patient/update-patiet-coords`,
        method: "POST",
        body: { ...credentials },
      }),
    }),
    getInsuranceMeta: builder.mutation({
      query: (credentials) => ({
        url: `/patient/insurance-meta/${credentials}`,
        method: "GET",

      }),
    }),

    getCareProgram: builder.mutation({
      query: (credentials) => ({
        url: `/patient/get-care-program/${credentials}`,
        method: "GET",

      }),
    }),
  }),
});

export const {
  useFetchPatientByIdMutation,
  useFetchPatientCareteamMutation,
  useFetchPatientHouseholdMembersMutation,
  useFetchPatientPOCMembersMutation,
  useFetchPatientPrimaryProviderMutation,
  useFetchPatientPrimaryLocationMutation,
  useGetNewPatientsMutation,
  useCreatePOCMutation,
  useUpdatePOCMutation,
  useDeletePOCMutation,
  useUpdatePatientNotesMutation,
  useUpdatePatientMutation,
  useCreatePatientMutation,
  useFetchPlannerPatientsMutation,
  useGetInsurancesMutation,
  useUpdateInsuranceMutation,
  useGetLocationsMutation,
  useSuggestLocationsMutation,
  useAttachLocationMutation,
  useValidateCoordsMutation,
  useUpdateCoordsMutation,
  useGetInsuranceMetaMutation,
  useGetCareProgramMutation
} = patientApiSlice;
